// extracted by mini-css-extract-plugin
export default {"theme1":"NoPayoutsIcon_theme1__M0mRH","theme2":"NoPayoutsIcon_theme2__lslOL","theme3":"NoPayoutsIcon_theme3__yTqbi","theme4":"NoPayoutsIcon_theme4__YbjRn"};